import {
    GetUsers,
    GetPrevilage,
    GetAccessModule,
    GetPrevilageAll,
    GetHelpdeskCS,
    GetSupervisor,
    GetSupervisorAll,
    GetTemplate,
    GetCategory,
    GetClientAll,
    GetGroupTemplate,
    GetDivisionAll,
    GetUserAll,
    GetHoliday,
    GetPriority,
    GetBusinessHour,
    GetKeyGroup,
    GetKeyGroupAll,
    GetReply,
    GetInvalidReply,
    GetWAProfile,
    GetSenderAll,
    GetTemplateAll,
    GetUploadDetail,
    GetTicketHistory,
    GetDetailTicket,
    GetReportBroadCastList,
    GetReportInteractive,
    GetReportHelpdesk,
    GetHelpdeskCSAll,
    GetPriorityAll,
    GetCategoryAll,
    GetHSMTemplate,
    GetHSMTemplateAll,
    GetWaProfileSetting,
    GetTemplateFirst,
    GetWaProfileImage,
    GetRepliesCloseTicket,
    GetCategoryTemplate,
    GetLanguageTemplate,
    GetTemplateFacebook,
    GetNameSpace,
    GetTransmitter,
    GetDivisionSetting,
    GetSenderSetting,
    GetTemplateSender,
    GetAccessModuleAction,
    GetCheckContact,
    GetBotInquiry,
    GetInteractiveSummary,
    GetTotalTicket,
    GetTicketHour,
    GetTicketTopic,
    GetAverage,
    GetTicketDay,
    GetVolumeBot,
    GetHomePushSummary,
    GetHomeInteractiveSummary,
    GetHomeTemplateSummary,
    GetDailyMessageByStatus,
    GetReadRateByDay, 
    GetReadRateByTime, 
    GetPushFormatDistribution,
    GetBatchName,
    GetHighestReadRate,
    GetUploadMediaId,
    GetMediaIdName,
    GetReportButtonList,
    GetReportSessionDashboard,
    GetReportSession,
    GetQualityRating,
    GetFacebookTemplateData,
    GetBacklogClient,
    GetFlowTemplateAll,
    GetFlowTemplate
} from '../constants';
import { fromJS } from 'immutable';

const initialState = {
    reportsessiondashboard:fromJS({}),
    reportsessionlist:fromJS({}),
    reportButton:fromJS({}),
    divisionsetting:fromJS({}),
    sendersetting:fromJS({}),
    mediaidname:fromJS({}),
    uploadmediaid:fromJS({}),
    volumebot:fromJS({}),
    ticketday:fromJS({}),
    average:fromJS({}),
    ticketstopic:fromJS({}),
    ticketshour:fromJS({}),
    totalsticket:fromJS({}),
    interactivesummary:fromJS({}),
    botinquiry: fromJS({}),
    checkcontacts:fromJS({}),
    users: fromJS({}),
    userall: fromJS({}),
    previlages: fromJS({}),
    previlagesall: fromJS({}),
    accessmodules: fromJS({}),
    accessmodulestime : '',
    helpdeskcs: fromJS({}),
    supervisors: fromJS({}),
    supervisorsall: fromJS({}),
    template: fromJS({}),
    categories: fromJS({}),
    clientall: fromJS({}),
    clientsmsall: fromJS({}),
    grouptemplate: fromJS({}),
    divisionall: fromJS({}),
    divisionsmsall: fromJS({}),
    masksms: fromJS({}),
    holidays: fromJS({}),
    priority: fromJS({}),
    keygroups: fromJS({}),
    keygroupall: fromJS({}),
    businesshour : fromJS({}),
    autoreply: fromJS({}),
    businesshourtime : '',
    invalidreply: fromJS({}),
    waprofiles: fromJS({}),
    senders: fromJS({}),
    invalidreplytime : '',
    templateall: fromJS({}),
    uploaddetail: fromJS({}),
    tickethistory: fromJS({}),
    detailticket: fromJS({}),
    reportBroadcast: fromJS({}),
    reportInteractive: fromJS({}),
    reportHelpdesk: fromJS({}),
    helpdeskcsAll: fromJS({}),
    priorityAll: fromJS({}),
    categoryAll: fromJS({}),
    hsmtemplate: fromJS({}),
    hsmtemplateAll: fromJS({}),
    templatefirst: fromJS({}),
    waprofileimage: '',
    isLoading: false,
    repliescloseticket: fromJS({}),
    categoryTemplate : fromJS({}),
    languageTemplate: fromJS({}),
    templatefacebook: fromJS({}),
    getnamespace: fromJS({}),
    gettransmitter: fromJS({}),
    templatesender: fromJS({}),
    accessmoduleaction: fromJS({}),
    homepushsummary: fromJS({}),
    homeinteractivesummary: fromJS({}),
    hometemplatesummary: fromJS({}),
    getdailymessagebystatus: fromJS({}),
    getreadratebyday: fromJS({}),
    getreadratebytime: fromJS({}),
    getpushformatdistribution: fromJS({}),
    getbacthname: fromJS({}),
    gethighestreadrate: fromJS({}),
    qualityrating: fromJS({}),
    facebookTemplateData: fromJS({}),
    backlogClientData: fromJS({}),
    flowTemplateAll: fromJS({}),
};

export default (state, action) => {
    state = state || initialState;

    if (action.type === GetUsers) {
        return {
            ...state,
            users: action.users,
        };
    }

    if(action.type === GetPrevilage){
        return {
            ...state,
            previlages: action.previlages,
        };
    }

    if(action.type === GetPrevilageAll){
        return {
            ...state,
            previlagesall: action.previlages,
        };
    }

    if(action.type === GetCheckContact){
        return {
            ...state,
            checkcontacts: action.checkcontacts,
        };
    }
    
    if(action.type === GetAccessModule){
        return {
            ...state,
            accessmodules: action.accessmodules,
            accessmodulestime: action.time
        };
    }

    if(action.type === GetHelpdeskCS){
        return {
            ...state,
            helpdeskcs: action.data,
        };
    }

    if(action.type === GetSupervisor){
        return {
            ...state,
            supervisors: action.data,
        };
    }

    if(action.type === GetSupervisorAll){
        return {
            ...state,
            supervisorsall: action.data,
        };
    }

    if(action.type === GetTemplate){
        return {
            ...state,
            template: action.data,
        };
    }

    if(action.type === GetTemplateAll){
        return {
            ...state,
            templateall: action.data,
        };
    }

    if(action.type === GetCategory){
        return {
            ...state,
            categories: action.data,
        };
    }

    if(action.type === GetClientAll){
        return {
            ...state,
            clientall: action.data,
        };
    }

    if(action.type === GetDivisionAll){
        return {
            ...state,
            divisionall: action.data,
        };
    }
    if(action.type === GetUserAll){
        return {
            ...state,
            userall: action.data,
        };
    }
    if(action.type === GetHoliday){
        return {
            ...state,
            holidays: action.data,
        };
    }

    if(action.type === GetPriority){
        return {
            ...state,
            priority: action.data,
        };
    }
    
    if(action.type === GetBusinessHour){
        return {
            ...state,
            businesshour: action.data,
            businesshourtime : action.time
        };
    }

    if(action.type === GetKeyGroup){
        return {
            ...state,
            keygroups: action.data,
        };
    }

    if(action.type === GetKeyGroupAll){
        return {
            ...state,
            keygroupall: action.data,
        };
    }

    if(action.type === GetReply){
        return {
            ...state,
            autoreply: action.data,
        };
    }
    
    if(action.type === GetInvalidReply){
        return {
            ...state,
            invalidreply: action.data,
            invalidreplytime : action.time,
        };
    }

    if(action.type === GetWAProfile){
        return {
            ...state,
            waprofiles: action.data,
        };
    }

    if(action.type === GetSenderAll){
        return {
            ...state,
            senders: action.data,
        };
    }

    if(action.type === GetUploadDetail){
        return {
            ...state,
            uploaddetail: action.data,
        };
    }

    if(action.type === GetTicketHistory){
        return {
            ...state,
            tickethistory: action.data,
        };
    }

    if(action.type === GetDetailTicket){
        return {
            ...state,
            detailticket: action.data,
        };
    }

    if(action.type === GetReportBroadCastList){
        return {
            ...state,
            reportBroadcast: action.data,
        };
    }

    if(action.type === GetReportInteractive){
        return {
            ...state,
            reportInteractive: action.data,
        };
    }

    if(action.type === GetReportHelpdesk){
        return {
            ...state,
            reportHelpdesk: action.data,
        };
    }

    if(action.type === GetHelpdeskCSAll){
        return {
            ...state,
            helpdeskcsAll: action.data,
        };
    }

    if(action.type === GetPriorityAll){
        return {
            ...state,
            priorityAll: action.data,
        };
    }

    if(action.type === GetCategoryAll){
        return {
            ...state,
            categoryAll: action.data,
        };
    }
    if(action.type === GetHSMTemplate){
        return {
            ...state,
            hsmtemplate: action.data,
        };
    }

    if(action.type === GetHSMTemplateAll){
        return {
            ...state,
            hsmtemplateAll: action.data,
        };
    }

    
    if(action.type === GetTransmitter){
        return {
            ...state,
            gettransmitter: action.data,
            
        };
    }

    if(action.type === GetTemplateSender){
        return {
            ...state,
            templatesender: action.data,
        };
    }

    if(action.type === GetAccessModuleAction){
        return {
            ...state,
            accessmoduleaction: action.data,
        };
    }

    if(action.type === GetWaProfileSetting){
        return {
            ...state,
            waprofilesetting: action.data,
        };
    }

    if(action.type === GetTemplateFirst){
        return {
            ...state,
            templatefirst: action.data,
        };
    }

    if(action.type === GetWaProfileImage){
        return {
            ...state,
            waprofileimage: action.data,
        };
    }

    if(action.type === GetGroupTemplate){
        return {
            ...state,
            grouptemplate: action.data,
        };
    }

    if(action.type === GetRepliesCloseTicket){
        return {
            ...state,
            repliescloseticket: action.data,
        };
    }

    if (action.type === GetCategoryTemplate){
        return {
            ...state,
            categoryTemplate: action.data,
        };
    }

    if (action.type === GetLanguageTemplate){
        return {
            ...state,
            languageTemplate: action.data,
        };
    }
    if (action.type === GetTemplateFacebook){
        return {
            ...state,
            templatefacebook: action.data,
        };
    }

    if(action.type === GetNameSpace) {
        return {
            ...state,
            getnamespace: action.data
        }
    }
 
    if(action.type === GetBotInquiry){
        return {
            ...state,
            botinquiry: action.data,
        };
    }

    if(action.type === GetInteractiveSummary){
        return {
            ...state,
            interactivesummary: action.data,
        };
    }

    if(action.type === GetTotalTicket){
        return {
            ...state,
            totalsticket: action.data,
        };
    }

    if(action.type === GetTicketHour){
        return {
            ...state,
            ticketshour: action.data,
        };
    }

    if(action.type === GetTicketTopic){
        return {
            ...state,
            ticketstopic: action.data,
        };
    }

    if(action.type === GetAverage){
        return {
            ...state,
            average: action.data,
        };
    }

    if(action.type === GetTicketDay){
        return {
            ...state,
            ticketday: action.data,
        };
    }

    if(action.type === GetVolumeBot){
        return {
            ...state,
            volumebot: action.data,
        };
    }

    
    if(action.type === GetHomePushSummary){
        return {
            ...state,
            homepushsummary: action.data,
        };
    }

    if(action.type === GetHomeInteractiveSummary){
        return {
            ...state,
            homeinteractivesummary: action.data,
        };
    }
    if(action.type === GetHomeTemplateSummary){
        return {
            ...state,
            hometemplatesummary: action.data,
        };
    }
    if(action.type === GetDailyMessageByStatus){
        return {
            ...state,
            hometemplatesummary: action.data,
        };
    }
    if(action.type === GetReadRateByDay){
        return {
            ...state,
            getreadratebyday: action.data,
        };
    }
    if(action.type === GetReadRateByTime){
        return {
            ...state,
            getreadratebytime: action.data,
        };
    }
    if(action.type === GetPushFormatDistribution){
        return {
            ...state,
            getpushformatdistribution: action.data,
        };
    }

    if(action.type === GetBatchName){
        return {
            ...state,
            getbacthname: action.data,
        };
    }

    if(action.type === GetHighestReadRate){
        return {
            ...state,
            gethighestreadrate: action.data,
        };
    }
    
    if(action.type === GetUploadMediaId){
        return {
            ...state,
            uploadmediaid: action.data,
        };
    }

    if(action.type === GetMediaIdName){
        return {
            ...state,
            mediaidname: action.data,
        };
    }
    
    if(action.type === GetReportButtonList){
        return {
            ...state,
            reportButton: action.data,
        };
    }

    if(action.type === GetDivisionSetting){
        return {
            ...state,
            divisionsetting: action.data,
        };
    }

    if(action.type === GetSenderSetting){
        return {
            ...state,
            sendersetting: action.data,
        };
    }

    if(action.type === GetReportSessionDashboard){
        return {
            ...state,
            reportsessiondashboard: action.data,
        };
    }

    if(action.type === GetReportSession){
        return {
            ...state,
            reportsessionlist: action.data,
        };
    }

    if(action.type === GetQualityRating){
        return {
            ...state,
            qualityrating: action.data,
        };
    }

    if (action.type === GetFacebookTemplateData) {
        return {
            ...state,
            facebookTemplateData: action.data,
        }
    }
    
    if (action.type === GetBacklogClient) {
        return {
            ...state,
            backlogClientData: action.data,
        }
    }

    if (action.type === GetFlowTemplateAll) {
        return {
            ...state,
            flowTemplateAll: action.data,
        }
    }

    if (action.type === GetFlowTemplate) {
        return {
            ...state,
            flowTemplate: action.data,
        }
    }
    
    return state;
};
